export default {
  columnFileName: '文件名称',
  columnImageVideo: '图片/视频',
  columnFileSize: '文件大小',
  columnUploadTime: '上传时间',
  columnAction: '操作',

  statusCompleted: '已完成',
  statusInProgress: '进行中',
  statusUnknown: '未知',

  download: '下载',
  noValue: '--',
  sizeMb: '{value} MB',
}
